<template>
  <div
    class="card border"
    :class="{'bg-success': selected}"
  >
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div>
          <div
            class="lead f-w-600"
            :class="[selected?'text-white':'text-dark']"
          >
            {{ period.name }}
          </div>
          <div :class="[selected?'text-white':'text-primary']">
            {{ $t('packagePeriodItem.gn', {days: period.days}) }}
          </div>
        </div>
        <div>
          <div
            v-if="discount>0"
            class="badge "
            :class="[selected?'badge-light':'badge-success']"
          >
            {{ $t('packagePeriodItem.endirim', {discount: discount}) }}
          </div>

        </div>
      </div>
      <div
        v-if=" trialUsed || pack.trialDays<1 || !period.hasTrial"
        class="d-flex justify-content-between align-items-bottom mt-3"
      >
        <div
          class="lead  f-w-600"
          :class="[selected?'text-white':'text-primary']"
        >
          {{ monthlyPrice }} AZN/ay
        </div>
        <div>
          <div class="text-right">
            <div
              v-if="period.oldPrice>period.price"
              class="text-danger lead"
            >
              <s>{{ $t('packagePeriodItem.azn', {oldPrice: period.oldPrice}) }}</s>
            </div>
            <div class="text-dark lead font-weight-bold">
              {{ $t('offerExtrasView.azn', {price: period.price}) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PackagePeriodItem',
  props: {
    pack: {
      type: Object,
      required: true
    },
    period: {
      type: Object,
      required: true
    },
    selected: false,
    trialUsed: true
  },
  computed: {

    monthlyPrice() {
      return (this.period.price / (this.period.days / 30)).toFixed(2);
    },
    discount() {
      if (this.period.oldPrice > 0) {
        return Math.round((1 - (this.period.price / this.period.oldPrice)) * 100);
      } else {
        return 0;
      }
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
